import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { SidebarModule } from '../constants/Enums';
import { LayoutType } from '../constants/LayoutConstants';
import { TooltipActions } from '../actions/TooltipActions';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { CoreTooltip } from './CoreTooltip';

import utils = egr.wcf.utils;

interface SidebarButtonProps extends React.Props<SidebarButton> {
    name: string;
    module: SidebarModule;
    active: boolean;
    disabled: boolean;
    count: number;
    layoutType: LayoutType;
    label?: string;
    newsCount?: number;
    infotext?: string;
}

export class SidebarButton extends BaseComponent<SidebarButtonProps, {}> {
    public render(): JSX.Element {
        return (
            <div className={this.getCSSClass()} onClick={this.onClick}>
                {this.getNewsCounter()}
                {this.getTooltip()}
            </div>
        );
    }

    protected getNewsCounter = (): JSX.Element | null => {
        if (this.props.newsCount == null || this.props.newsCount <= 0) {
            return null;
        }

        return (
            <div className="news-counter">{this.props.newsCount}</div>
        );
    };

    protected getTooltip = (): JSX.Element | null => {
        if (utils.string.isNullOrEmpty(this.props.label) || this.props.active || this.props.disabled) {
            return null;
        }

        return (
            <CoreTooltip config={{label: this.props.label, forceLabel: this.props.infotext}}/>
        );
    };

    protected onClick = (): void => {
        TooltipActions.hideTooltip();
        ViewSettingsActions.changeSidebar(
            this.props.active ? SidebarModule.NONE : this.props.module
        );
    };

    protected getCSSClass = (): string => {
        const className: Array<string> = ['sidebar-tab-button'];

        if (this.props.name == null) {
            className.push('config-button');
        } else {
            className.push(this.props.name + '-button');
        }

        if (this.props.active) {
            className.push('sidebar-tab-button-active');
        }

        if (this.props.disabled) {
            className.push('sidebar-tab-button-disabled');
        }

        return className.join(' ');
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SidebarButton.tsx